const PropertyDetailErrorState = ({ message, onRetry, onBack }) => (
  <div className="property-detail-state property-detail-state--error" role="alert">
    <h2>Unable to load this property</h2>
    <p>{message || "Something went wrong while loading property details."}</p>
    <div className="property-detail-state__actions">
      {onRetry ? (
        <button type="button" className="midpoint-share-button" onClick={onRetry}>
          Try again
        </button>
      ) : null}
      {onBack ? (
        <button type="button" className="midpoint-share-button midpoint-share-button--ghost" onClick={onBack}>
          Back to results
        </button>
      ) : null}
    </div>
  </div>
);

export default PropertyDetailErrorState;
